import { spacing } from 'ext-ui/style/spacing'
import { css } from 'styled-components'

export default css`
  .receiptRecoveryPage-title {
    align-items: center;
    display: inline-flex;
    gap: ${spacing(3)};
  }
`
